var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-423bf9ae": "",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 539 107",
    className: "iconLeft",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-v-423bf9ae": "",
    id: "49caf5da-4fb2-4aa5-b870-64646d3105cb",
    fill: "#342103",
    transform: "matrix(5.449591167364901,0,0,5.449591167364901,101.49343795562248,-1.3165320135285299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.55 15.33L9.25 15.33L6.15 4.66L3.26 4.66L0.14 15.33L2.74 15.33L3.32 12.84L5.98 12.84ZM4.65 7.08L5.49 10.71L3.81 10.71ZM16.56 4.66L10.23 4.66L10.23 15.33L12.67 15.33L12.67 11.30L15.79 11.30L15.79 9.13L12.67 9.13L12.67 6.83L16.56 6.83ZM22.44 11.49L22.44 11.83C22.41 12.82 21.99 13.23 21.18 13.23C20.22 13.23 19.87 12.73 19.87 11.55L19.87 8.48C19.87 7.28 20.23 6.76 21.18 6.76C21.97 6.76 22.43 7.20 22.43 8.16L22.43 8.39L25.02 8.39L25.02 8.20C25.02 5.80 23.73 4.49 21.18 4.49C18.55 4.49 17.32 5.87 17.32 8.36L17.32 11.65C17.32 14.13 18.55 15.50 21.18 15.50C23.76 15.50 25.02 14.18 25.03 11.79L25.03 11.49ZM34.44 15.33L34.44 6.83L36.93 6.83L36.93 4.66L29.54 4.66L29.54 6.83L32.02 6.83L32.02 15.33ZM43.12 15.33L45.86 15.33L44.07 10.93C44.98 10.43 45.39 9.56 45.39 8.19L45.39 7.98C45.39 5.73 44.23 4.66 41.65 4.66L38.26 4.66L38.26 15.33L40.64 15.33L40.64 11.45L41.80 11.45ZM40.64 6.78L41.68 6.78C42.66 6.78 43.01 7.06 43.01 8.02L43.01 8.11C43.01 9.03 42.73 9.34 41.72 9.34L40.64 9.34ZM52.74 15.33L55.44 15.33L52.33 4.66L49.45 4.66L46.33 15.33L48.93 15.33L49.50 12.84L52.16 12.84ZM50.83 7.08L51.67 10.71L49.99 10.71ZM59.75 4.66L56.42 4.66L56.42 15.33L59.77 15.33C62.57 15.33 63.84 13.99 63.84 11.40L63.84 8.64C63.84 6.01 62.58 4.66 59.75 4.66ZM59.79 6.85C60.84 6.85 61.29 7.32 61.29 8.48L61.29 11.52C61.29 12.68 60.84 13.16 59.78 13.16L58.79 13.16L58.79 6.85ZM67.86 6.83L71.79 6.83L71.79 4.66L65.42 4.66L65.42 15.33L71.93 15.33L71.93 13.16L67.86 13.16L67.86 11.00L71.20 11.00L71.20 8.88L67.86 8.88ZM75.82 10.84C77.32 11.19 77.78 11.51 77.78 12.28C77.78 13.02 77.38 13.40 76.47 13.40C75.39 13.40 75.04 12.94 75.01 12.24L72.60 12.24C72.60 13.94 73.54 15.50 76.36 15.50C79.20 15.50 80.22 14.21 80.22 12.21C80.22 9.66 78.29 9.18 76.68 8.79C75.57 8.54 75.18 8.20 75.18 7.50C75.18 6.96 75.46 6.59 76.24 6.59C77.15 6.59 77.50 6.92 77.60 7.71L80.01 7.71C79.83 5.33 78.46 4.49 76.26 4.49C74.00 4.49 72.80 5.59 72.80 7.59C72.80 10.00 74.33 10.44 75.82 10.84Z"
  }))), /*#__PURE__*/React.createElement("defs", {
    "data-v-423bf9ae": ""
  }, /*#__PURE__*/React.createElement("linearGradient", {
    "data-v-423bf9ae": "",
    gradientTransform: "rotate(25)",
    id: "363100ca-c877-401f-92fa-8e04e82190da",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    "data-v-423bf9ae": "",
    offset: "0%",
    style: {
      stopColor: "rgb(229, 101, 0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    "data-v-423bf9ae": "",
    offset: "100%",
    style: {
      stopColor: "rgb(235, 197, 29)",
      stopOpacity: 1
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-v-423bf9ae": "",
    id: "00d93ec4-ec71-4977-837d-c6ca884cb359",
    transform: "matrix(1.0868111504448785,0,0,1.0868111504448785,-13.255261890115804,-0.23894260335429607)",
    stroke: "none",
    fill: "url(#363100ca-c877-401f-92fa-8e04e82190da)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.983 10.59l17.018 88.223-5.872-59.049 29.021-1.892-.054-9.883L64.549 1 53.622 18.977z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.389 54.548l5.16-53.541-8.74 39.716-19.612 1.045 1.57 20.462-7.766 36.583 12.057-39.899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8 67.182l.549-10.453-15.979 3.755-.032 11.797-17.337 26.532 21.68-27.616zM65.711 62.394l14.841-4.731 1.509-12.532-15.899 2.095zM72.07 44.502l10.988-1.417 1.581-10.278-8.079-.373L64.549 1l8.43 30.967z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.413 31.294l1.256-9.506-9.544-2.694L64.549 1l14.483 22.437-.422 7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d585d4b4be5ae88fb022e86197156fd6.svg";
export { ForwardRef as ReactComponent };